const type = {
  iphone: 2,
  android: 1,
  other: 0
};
export default {
  data(){
    return {
      type,
      userData: {
        isLogin: 1,
        headImg: "",
        nickName: "",
        expirationTimestamp: 1548052735000,
        account:""
      },
    }
  },
  async created() {
    console.info(this.mobileType);
    switch (this.mobileType) {
      case this.type.iphone:
        this.$app(bridge => {
          bridge.callHandler("getUserData", {}, responseData => {
            this.userData = JSON.parse(responseData);
            console.info(JSON.parse(responseData));
          });
        });
        break;
      case this.type.android:
        this.userData = JSON.parse(MemberJs.getUserData());
        break;
      case this.type.other:
        alert("手机型号不支持，请与客服联系。谢谢！");
        break;
    }
  },
  methods:{
    buy(item) {
      if (!item.goodsNum) {
        alert("购买出错，请与客服联系。谢谢！");
        return;
      }
      switch (this.mobileType) {
        case this.type.iphone:
          this.$app(bridge => {
            bridge.callHandler(
              "productBuy",
              JSON.stringify({ productId: item.goodsNum,thirdGoodsNum:item.thirdGoodsNum}),
              responseData => {
                console.log("JS received response:", responseData);
              }
            );
          });
          break;
        case this.type.android:
          MemberJs.productBuy(
            JSON.stringify({ productId: item.goodsNum })
          );
          break;
        case this.type.other:
          alert("手机型号不支持，请与客服联系。谢谢！");
          break;
      }
    }
  },
  computed: {
    mobileType() {
      let result = this.type.other;
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        result = this.type.iphone;
      } else if (/(Android|Adr)/i.test(navigator.userAgent)) {
        result = this.type.android;
      }
      return result;
    }
  }
} 